module.exports = __webpack_public_path__ + "img/my1.88032b67.png";